import { render, staticRenderFns } from "./bussiness-dashboard.vue?vue&type=template&id=6d183af2&lang=pug&"
import script from "./bussiness-dashboard.vue?vue&type=script&lang=js&"
export * from "./bussiness-dashboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports